var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"escalaGrisesFuncion"}},[_c('nav-gob'),_c('nav-hacienda'),_vm._v(" "),_c('router-view',{staticStyle:{"min-height":"85vh !important"}})],1),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }